"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var filter_tree_dto_factory_1 = require("./filter-tree-dto-factory");
/**
 * Boolean expression tree for filters. An expression contains <CODE>AND|OR</CODE> operator and operands which are
 * filters or another expressions.
 *
 * Created by Hayk.Andriasyan on 5/23/2017.
 */
var FilterTreeDto = /** @class */ (function () {
    function FilterTreeDto() {
    }
    FilterTreeDto.fromJson = function (filterJson) {
        return filter_tree_dto_factory_1.FilterTreeDtoFactory.fromJson(filterJson);
    };
    FilterTreeDto.prototype.toJson = function () {
        return JSON.stringify(this);
    };
    return FilterTreeDto;
}());
exports.FilterTreeDto = FilterTreeDto;
//# sourceMappingURL=filter-tree-dto.js.map